module.exports = __webpack_public_path__ + "img/fib_tree.2a8fb427.jpg";